import style from './style.module.scss';
import {Box} from 'components/Grid';
import {EventBanner} from 'modules/events/components/EventBanner';
import {Breadcrumbs} from 'modules/breadcrumbs/components/Breadcrumbs';
import {useRouter} from 'next/router';
import {AboutTasting} from 'modules/events/components/AboutTasting';
import {Faq} from 'modules/events/components/Faq';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import dynamic from 'next/dynamic';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {useGetEventQuery} from 'modules/events/services';
import {IProductShortResponse} from 'modules/products/models';
import {EventBuyButtonMobile} from 'modules/events/components/EventBuyButtonMobile';
import {EventInfo} from 'modules/events/components/EventInfo';
import {TastingCertificateInfoModal} from 'modules/events/components/BannerCertificateModal';
import {BannerCertificateLarge} from 'modules/events/components/BannerCertificateLarge';
import {EventXTastingProducts} from 'modules/events/components/EventXTastingProducts';
import {EventXOffer} from 'modules/events/components/GiftCertificate';
import {IBreadcrumb} from 'modules/seo/types';
import {PAGES} from 'core/modules/routing/constants';

const RegisterToTastingModal = dynamic(() => import('modules/events/components/RegisterToTastingModal'), {
    loading: () => <ModalLazyLoader />,
});

const TastingSuccessModal = dynamic(() => import('modules/events/components/TastingSuccessModal'), {
    loading: () => <ModalLazyLoader />,
});

interface IEventXPageProps {
    tastingProductsData?: IProductShortResponse;
    breadcrumbs?: IBreadcrumb[];
}

function EventXPage({tastingProductsData, breadcrumbs = []}: IEventXPageProps) {
    const {query, asPath} = useRouter();

    const {data} = useGetEventQuery({id: query.slug as string});
    const event = data?.data;

    if (!event) {
        return null;
    }

    const {
        detailedDescription,
        title,
        isYClients,
        ycActivityId,
        eventDate,
        eventTimeBegin,
        eventTimeEnd,
        price,
        type,
        detailedImage,
    } = event;

    return (
        <>
            <Box>
                <Breadcrumbs
                    breadcrumbs={
                        0 < breadcrumbs.length
                            ? breadcrumbs
                            : [
                                  {name: PAGES.HOME_PAGE.title, url: PAGES.HOME_PAGE.path},
                                  {
                                      name: PAGES.EVENTS_PAGE.title,
                                      url: PAGES.EVENTS_PAGE.path,
                                  },
                                  {name: title, url: asPath},
                              ]
                    }
                />
            </Box>
            <article className={style.eventXPage} itemScope={true} itemType={'https://schema.org/Event'}>
                <Box className={style.bannerWrapper}>
                    <EventBanner
                        eventTimeEnd={eventTimeEnd}
                        isYClients={isYClients}
                        ycActivityId={ycActivityId}
                        image={detailedImage}
                        eventDate={eventDate}
                        type={type}
                        price={price}
                        eventTimeBegin={eventTimeBegin}
                        title={title}
                    />
                </Box>
                <div className={style.eventInfo}>
                    <EventInfo />
                </div>

                {Boolean(tastingProductsData?.items?.length || detailedDescription) && (
                    <div className={style.tastingProducts}>
                        <EventXTastingProducts tastingProductsData={tastingProductsData} />
                    </div>
                )}

                <div className={style.aboutTasting}>
                    <AboutTasting />
                </div>
                <div className={style.faq}>
                    <Faq />
                </div>
                <EventBuyButtonMobile />
                <div className={style.bannerCertificate}>
                    <BannerCertificateLarge />
                </div>
                <div className={style.offer}>
                    <EventXOffer />
                </div>
            </article>
            <Modal name={MODALS.REGISTER_TO_TASTING_MODAL.name} willMount={true}>
                <RegisterToTastingModal />
            </Modal>
            <Modal name={MODALS.TASTING_SUCCESS.name} willMount={true}>
                <TastingSuccessModal />
            </Modal>
            <Modal name={MODALS.TASTING_CERTIFICATE_INFO.name} willMount={true}>
                <TastingCertificateInfoModal />
            </Modal>
        </>
    );
}

export default EventXPage;
